export enum ESchoolIds {
  ENROLLMENT_NUMBER = 'enrollment-number',
  ENTRY_POLICY = 'entry-policy',
  ATTENDANCE_POLICY = 'attendance-policy',
  MOBILE_SETTINGS = 'mobile-settings',
}

export const schoolPageFragments = [
  {
    title: 'SETTINGS.GENERAL.ENROLLMENT_NUMBER.TITLE',
    id: ESchoolIds.ENROLLMENT_NUMBER,
  },
  {
    title: 'SETTINGS.GENERAL.ENTRY_POLICY.TITLE',
    id: ESchoolIds.ENTRY_POLICY,
  },
  {
    title: 'SETTINGS.GENERAL.ATTENDANCE_POLICY.TITLE',
    id: ESchoolIds.ATTENDANCE_POLICY,
  },
  {
    title: 'SETTINGS.GENERAL.MOBILE_SETTINGS.TITLE',
    id: ESchoolIds.MOBILE_SETTINGS,
  },
];
